import { mapState } from 'vuex';

import formatterMixin from './formatterMixin';
import emailValidation from '../lib/errorCatch/emailValidation';

const partnerAgreementMixin = {
  mixins: [formatterMixin],
  computed: {
    ...mapState({
      products: (state) => state.general.products,
      agreement: (state) => state.partnerAgreement.agreement,
      newAgreement: (state) => state.partnerAgreement.newAgreement,
      agreementPdf: (state) => state.partnerAgreement.agreementPdf,
    }),

    agreementOrders() {
      const { agreementOrders } = this.newAgreement;
      return agreementOrders;
    },
    adminUsers() {
      return this.$store.state.setting.platformSmacUsers
        .filter((p) => p.accountStatus === 'Active')
        .map((p) => ({
          value: p.id,
          label: `${p.email}`,
        }));
    },
    isReadyForSend() {
      const { adminId, contractPeriod, deploymentPeriod, notifyBillingEmail } = this.newAgreement;
      return adminId && contractPeriod && deploymentPeriod && notifyBillingEmail;
    },
    lastAgreement() {
      const { agreementOrders } = this.newAgreement;
      return agreementOrders?.length && agreementOrders[agreementOrders.length - 1];
    },
    isValidAgreement() {
      const { platformFee, connectFee, connectProduct, gen2Preorder, agreementOrders } =
        this.newAgreement;
      const hasDetect = agreementOrders.find((order) =>
        order.agreementOrderLines.find((ol) => ol.subscriptionPlanId?.includes('PM')),
      );
      if (
        !this.newAgreement.manualPayment &&
        (this.newAgreement.notifyBillingEmail === null ||
          this.newAgreement.notifyBillingEmail === '' ||
          !emailValidation(this.newAgreement.notifyBillingEmail))
      ) {
        return false;
      }
      if (hasDetect && !this.newAgreement.totalKitCommitment) {
        return false;
      }
      if (hasDetect && !this.newAgreement.contractPeriod) {
        return false;
      }
      if (hasDetect && !this.newAgreement.deploymentPeriod) {
        return false;
      }
      if (!platformFee && !connectFee && !gen2Preorder && !hasDetect) {
        return false;
      }
      if (connectFee && !connectProduct) {
        return false;
      }
      let validCount = 0;
      agreementOrders.forEach((item) => {
        const detectOl = item.agreementOrderLines.find((ol) => ol.sku?.includes('PM'));
        if (!detectOl || this.isValidShipment(item)) {
          validCount += 1;
        }
      });
      return validCount === agreementOrders.length;
    },
  },
  methods: {
    onChangeAgreement(field, value) {
      const newAgreement = {
        ...this.newAgreement,
        [field]: value,
      };
      if (field === 'manualPayment' && value) {
        newAgreement.notifyBillingEmail = '';
      }
      if (field === 'platformFee' && value) {
        newAgreement.platformFeeAmount = 1000;
      }
      this.$store.dispatch('changePartnerAgreementValues', [
        {
          field: 'newAgreement',
          value: newAgreement,
        },
      ]);
    },
    isValidOrder(order) {
      const { productId, quantity, total, version, vendor } = order;
      const product = this.products.find((p) => p.id === productId);
      const skuRequired =
        product?.sku.includes('PM') ||
        (product?.sku.includes('CS') && product?.category === 'Sensors') ||
        (product?.sku.includes('FS') && product?.category === 'Sensors') ||
        (product?.sku.includes('WS') && product?.category === 'Sensors');
      return !!(
        productId &&
        quantity &&
        total &&
        vendor &&
        ((skuRequired && version) || !skuRequired)
      );
    },
    isValidShipment(agreement) {
      const { shippingAddressId, shippingCost, plannedStartDate, agreementOrderLines } = agreement;
      let validCount = 0;
      agreementOrderLines.forEach((item) => {
        if (this.isValidOrder(item)) {
          validCount += 1;
        }
      });
      return !!(
        shippingAddressId &&
        plannedStartDate &&
        shippingCost &&
        validCount === agreementOrderLines.length
      );
    },
  },
};

export default partnerAgreementMixin;
